import { useState } from 'react';
import { getProducts } from '../../services/productService';

const useProducts = () => {
  const [products, setProducts] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [productsRecommended, setProductsRecommended] = useState([]);
  const [loadingRecommended, setLoadingRecommended] = useState(true);
  const [errorRecommended, setErrorRecommended] = useState(null);

  // Función para obtener productos
  const fetchProducts = async (filter = { limit: 4 }) => {
    setLoading(true);

    try {
      const data = await getProducts(filter);
      setProducts(data);
      setLoading(false);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const getProductsShop = async (filter = { limit: 4 }) => {
    try {
      const data = await getProducts(filter);
      return data;
    } catch (err) {
        setError(err);
    } finally {}
  };

  // Función para obtener productos recomendados
  const fetchProductsRecommended = async (filter = { limit: 4 }) => {
    setLoadingRecommended(true);
    try {
      const data = await getProducts(filter);
      setProductsRecommended(data);
      setLoadingRecommended(false);
    } catch (err) {
      setErrorRecommended(err);
    } finally {
      setLoadingRecommended(false);
    }
  };

  return {
    products,
    setProducts,
    loading,
    setLoading,
    error,
    productsRecommended,
    loadingRecommended,
    errorRecommended,
    fetchProducts,
    getProductsShop,
    fetchProductsRecommended,
  };
};

export default useProducts;
